import React, { Component } from 'react';
import "../assects/css/Result.css";
import html2canvas from 'html2canvas';
import wxCode from "../assects/img/wxcode.png";
import logo from "../assects/img/logo.png";
import axios from "axios";
import storage from "../model/storage";
import questionTye from '../common/questionTye';
class Result extends Component {
  constructor(props) {
    super(props);
    this.saveRef = ref => {this.refDom = ref};
    this.state = {
        tolNUm:102,
        can_vas:"",
        dis_img:false,
        resData:{},
        msg:''
    };
  }
  componentWillMount(){
    if(this.props.location.state&&this.props.location.state.examId){
      
    }else{
      this.props.history.replace(`/?examId=${storage.get("examId")}&paperId=${storage.get("paperId")}&market=${storage.get("market")}`);
      window.location.reload();
    }
    document.title="成绩单_估分模考系统_山香教育";
    
  }
  saveRes=()=>{
    const {clientWidth, clientHeight} = this.refDom;
    
    //console.log(clientWidth);
    //console.log(clientHeight);
     var that=this;
    html2canvas(document.getElementById("saveCon"),{width:clientWidth,hight:clientHeight,useCORS: true}).then(function(canvas) {
        // console.log(canvas.toDataURL(),'2222222222222')
        //var url = canvas.toDataURL();
       // document.body.appendChild(canvas);
       that.setState({
            can_vas:canvas.toDataURL('image/png'),
            dis_img:true
        })
    });
  }
  none_img=()=>{
    this.setState({
        
        dis_img:false
    })
  }
  stop_Df=(e)=>{
    
    e.stopPropagation();
   
  }
  lookExam=()=>{
    if(this.props.location.state.examType==="1"){
      this.props.history.push( { pathname: "/Mk", state: { isDid:true,examId:this.props.location.state.examId,paperId:this.props.location.state.paperId,userId:this.props.location.state.userId}});
    }else{
      this.props.history.push( { pathname: "/GF", state: { isDid:true,examId:this.props.location.state.examId,paperId:this.props.location.state.paperId,userId:this.props.location.state.userId}});

    }
}
  
  componentDidMount(){
   
    var that = this;
    axios.get(storage.baseUrl+'/userExamResult', {
      params: {
        examId: that.props.location.state.examId,
        paperId: that.props.location.state.paperId,
        userId:that.props.location.state.userId
      }
    })
      .then(function (response) {
        //console.log(response);
        that.setState({
          resData:response.data,
          msg:response.data&&response.data.official?(response.data.official).replaceAll('||','\n'):''  
        })
       
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  }
  // wicthTitle=(type)=>{
  //   let Type;
  //   switch (type) {
  //     case "1001":
  //       Type = "单选题";
  //       break;
  //     case "1002":
  //       Type = "多选题";
  //       break;
  //     case "1003":
  //       Type = "判断题";
  //       break;
  //     case "1004":
  //       Type = "简答题";
  //       break;
  //     case "1008":
  //       Type = "辨析题";
  //       break;
  //     case "1005":
  //       Type = "材料分析题";
  //       break;
  //     case "1006":
  //       Type = "写作题";
  //       break;
  //     case "1007":
  //       Type = "教学设计题";
  //       break;
  //     case "1009":
  //       Type = "活动设计题";
  //       break;
  //     case "1010":
  //       Type = "论述题";
  //       break;
  //     case "1011":
  //       Type = "名词解释题";
  //       break;
  //     case "1012":
  //       Type = "案例分析题";
  //       break; 
  //     case "1013":
  //       Type = "填空题";
  //       break; 
  //     case "1014":
  //       Type = "解答题";
  //       break;
  //     case "1015":
  //       Type = "概述题";
  //       break;
  //     case "1016":
  //       Type = "不定项选择题";
  //       break;
  //     default: 
  //       Type = "综合";
  //       break;     
  // } 
  //  return Type;
  // }
  render() {
    return (
      <div>
        <div className="res_con" id="saveCon" ref={this.saveRef}>
                <img src={logo} className="res_logo" alt="logo" />
                {
                    this.props.location.state.examType==='1'? <div className="gf_title">{this.state.resData.examName}{this.state.resData.paperName}模考结果</div>:
                    <div className="gf_title">{this.state.resData.examName}{this.state.resData.paperName} 估分结果</div>
                  }
               
                <div className="res_content">
                    <div className="tolNum">{this.state.resData.userName}的总成绩为<span>{this.state.resData.gradeNum}</span>分</div>
                    <div className="res_sort">第<span className="sort_h">{this.state.resData.ranking}</span>名</div>
                    {
                      this.state.resData.datas&&this.state.resData.datas.map((val,index)=>{
                        return(
                          <div className="res_list" key={index}><span>{`${questionTye.handleType(val.questionType)}`}</span><span>{val.totalScore}分</span></div>
                        )
                      })
                    }
                    {/* {
                      this.props.location.state.examType==='1'?<div className="res_list"><span>用时</span><span>{this.state.resData.usringTime}</span></div>
                      :<div></div>
                    } */}
                    
                </div>

                
                  {
                    this.props.location.state.examType==='1'?<button className="saveRes" onClick={this.saveRes}>保存模考成绩单</button>:
                      <button className="saveRes" onClick={this.saveRes}>保存估分成绩单</button>
                  }
                  
                  
                <div className="lookExam" onClick={this.lookExam}>查看答案解析</div>

                <img src={this.state.resData&&this.state.resData.url?this.state.resData.url:wxCode} className="wx_code" alt="" crossorigin="anonymous"/>
                {/* <img src="https://image.shanxiangjiaoyu.com/1645522662308.jpg" className="wx_code" alt="" crossorigin="anonymous"/> */}
                {this.state.resData&&this.state.resData.official?<p className="res_tip">{this.state.msg}</p>:
                <p className="res_tip">教师之路，从山香起步！<br></br>
                {/* {
                    this.props.location.state.examType==='1'? <p className="res_tip">扫描或长按二维码，关注公众号，解锁更多备考权益</p>:
                       <p className="res_tip">关注公众号，回复“估分”，即可获得估分系统入口</p>
                  } */}
                  {
                    this.props.location.state.examType==='1'? '扫描或长按二维码，关注公众号，解锁更多备考权益':'关注公众号，回复“估分”，即可获得估分系统入口'
                  }
                  </p>
                }                                                                             
        </div>
        <div className={this.state.dis_img===true?"dis_img":"dis_img none"} onClick={this.none_img}>
          <p className="img_tip">长按图片保存到本地哦~</p>
        <img src={this.state.can_vas} onClick={this.stop_Df} alt="" />
        
        </div>
      </div>
    
    );
  }
}

export default Result;
